/**
 * AI 分析 - 数据摘要看板
 */
import React from 'react';
import { Card, Space, Typography, Row, Col, Alert } from 'antd';
import { DashboardOutlined, RiseOutlined, FallOutlined, MinusOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface KeyMetric {
  label: string;
  value: string | number;
  trend: string;
  description: string;
}

interface DataSummary {
  keyword: string;
  key_metrics: KeyMetric[];
  quick_insights?: string[];
}

interface AIDataSummaryProps {
  dataSummary?: DataSummary;
}

export const AIDataSummary: React.FC<AIDataSummaryProps> = ({ dataSummary }) => {
  if (!dataSummary) return null;

  const getTrendIcon = (trend: string) => {
    switch (trend) {
      case 'positive':
        return <RiseOutlined style={{ color: '#52c41a', fontSize: '16px' }} />;
      case 'negative':
        return <FallOutlined style={{ color: '#ff4d4f', fontSize: '16px' }} />;
      case 'stable':
        return <MinusOutlined style={{ color: '#8c8c8c', fontSize: '16px' }} />;
      default:
        return null;
    }
  };

  return (
    <Card
      title={
        <Space>
          <DashboardOutlined style={{ color: '#1890ff' }} />
          关键数据摘要
        </Space>
      }
      className="ai-content-card"
      style={{ marginBottom: 16 }}
    >
      {/* 关键词标题 */}
      <Title level={4} style={{ marginTop: 0, marginBottom: 24, color: '#262626' }}>
        {dataSummary.keyword}
      </Title>

      {/* 核心指标网格 */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        {dataSummary.key_metrics.map((metric, index) => (
          <Col xs={24} sm={12} md={8} key={index}>
            <Card
              size="small"
              bordered={false}
              style={{
                background: '#fafafa',
                borderRadius: 8,
                height: '100%',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  marginBottom: 8,
                }}
              >
                <Text type="secondary" style={{ fontSize: '13px' }}>
                  {metric.label}
                </Text>
                {getTrendIcon(metric.trend)}
              </div>
              <div style={{ fontSize: '20px', fontWeight: 600, color: '#262626', marginBottom: 8 }}>
                {metric.value}
              </div>
              <Text type="secondary" style={{ fontSize: '12px', lineHeight: '1.5' }}>
                {metric.description}
              </Text>
            </Card>
          </Col>
        ))}
      </Row>

      {/* 快速洞察 */}
      {dataSummary.quick_insights && dataSummary.quick_insights.length > 0 && (
        <Alert
          message="💡 快速洞察"
          description={
            <ul style={{ margin: '8px 0 0 0', paddingLeft: 20 }}>
              {dataSummary.quick_insights.map((insight, index) => (
                <li key={index} style={{ marginBottom: 4 }}>
                  {insight}
                </li>
              ))}
            </ul>
          }
          type="info"
          showIcon={false}
          style={{ background: '#e6f7ff', border: '1px solid #91d5ff', borderRadius: 8 }}
        />
      )}
    </Card>
  );
};

